import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69ac97ba886e1000142ac1dc_1789486721575_27b299f3/pickmeup/src/app/purchase/page.tsx");
